import { ChatModuleType } from 'app/copied/models/ChatModules';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useHorizontalButtons() {
  const { data: helpCenter } = useFetchHelpCenter();
  const horizontalButtonsModule = helpCenter?.modules?.find(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (module: any) => module.module_type === ChatModuleType.Container && module.orientation === 'horizontal'
  );

  return horizontalButtonsModule;
}
